import { render, staticRenderFns } from "./IconGlobe.vue?vue&type=template&id=479aac5a&scoped=true&"
import script from "./IconGlobe.vue?vue&type=script&lang=ts&"
export * from "./IconGlobe.vue?vue&type=script&lang=ts&"
import style0 from "./IconGlobe.vue?vue&type=style&index=0&id=479aac5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479aac5a",
  null
  
)

export default component.exports